import { Form, Input } from "antd";
import { Controller } from "react-hook-form";

const { TextArea } = Input;

// Reusable Form Field Component
const FormField = ({
  label,
  name,
  control,
  placeholder,
  validateStatus,
  help,
  inputType,
}) => {
  const InputComponent = inputType === "textarea" ? TextArea : Input;

  return (
    <Form.Item label={label} validateStatus={validateStatus} help={help}>
      <Controller
        name={name}
        control={control}
        render={({ field }) => (
          <InputComponent
            {...field}
            placeholder={placeholder}
            className="notifications__text-area"
          />
        )}
      />
    </Form.Item>
  );
};

export default FormField;
